import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtText from "../../../components/NtText";
import NtTouchableEffect from "../../../components/NtTouchableEffect";
import colors from "../../../config/colors";
import NtSectionButton from "../general/NtSectionButton";
import NtAppDownloadButton from "../general/NtAppDownloadButton";
import { useMobile } from "../../../hooks/useMobile";

function NtBusinessSection({}) {
  const isMobile = useMobile();
  return (
    <NtMarketingSectionContainer
      style={[styles.container, isMobile ? { height: 800 } : {}]}
      backgroundImage={require("../../../assets/images/marketing/b743f2b253db3a1230d1ccbea84eba254b6390d2.jpg")}
    >
      <View
        style={{
          flex: 1,
          flexDirection: isMobile ? "column" : "row",
          marginTop: 150,
        }}
      >
        <View style={{ flex: 1 }}>
          <NtSectionTitle
            style={{
              textAlign: "left",
              fontSize: 28,
              marginTop: 8,
              fontWeight: "300",
            }}
          >
            CLOUD BASED <NtText style={{ fontWeight: "800" }}>PBX</NtText>
          </NtSectionTitle>

          <NtSectionDescription style={{ marginTop: 8, fontWeight: "300" }}>
            Borderless Business Phone System.
          </NtSectionDescription>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
              marginTop: 40,
            }}
          >
            <NtAppDownloadButton
              type="android"
              containerStyle={{ marginRight: 15 }}
              onPress={() => {
                window.open(
                  "https://play.google.com/store/apps/details?id=org.netTalk.business"
                );
              }}
            />

            <NtAppDownloadButton
              type="apple"
              containerStyle={{}}
              onPress={() => {
                window.open(
                  "https://apps.apple.com/us/app/nettalk-pbx/id1452626133"
                );
              }}
            />
          </View>

          <NtSectionDescription style={{ marginTop: 15 }}>
            Big Business Features for Small Business.
          </NtSectionDescription>
          <View
            style={{
              marginTop: 10,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <NtSectionButton
              title="CUSTOMIZE"
              color="white"
              onPress={() => {
                window.open("https://account.ntconnect.com/site/login");
              }}
            />
          </View>
        </View>
        <View style={{ flex: 1, alignItems: "center" }}>
          <Image
            style={[
              {
                width: 150,
                height: 300,
                resizeMode: "contain",
              },
            ]}
            source={require("../../../assets/images/marketing/7afffde683a9bd23580f12ed3b03d5a71d7a944e.png")}
          />
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 600,
  },
});

export default NtBusinessSection;
